import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MESSAGES } from 'app/common/constants';
import { InspectionVersion } from 'app/core/interfaces/InspectionVersion';
import { AlertService } from 'app/core/services/alert.service';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { InspectionsService } from '../../core/services/inspections.service';
import { catchError, takeUntil } from 'rxjs/operators';
import { of, Subject } from 'rxjs';

@Component({
  selector: 'app-version-history',
  templateUrl: './version-history.component.html',
  styleUrls: ['./version-history.component.css']
})
export class VersionHistoryComponent implements OnInit, OnDestroy {
  @Input() inspId: string;
  destroy$ = new Subject();

  selectAll: boolean = false;
  reportVersions: InspectionVersion[] = [];
  selectedVersions: Set<number> = new Set();
  downloadLinks: HTMLIFrameElement[] = [];
  moment = moment;
  isLoading = false;

  constructor(
    private activeModal: NgbActiveModal,
    private inspectionService: InspectionsService,
    public alertService: AlertService) {
  }

  ngOnInit(): void {
    this.getReportVersions();
  }

  getReportVersions() {
    this.isLoading = true;
    Swal.fire('Please wait');
    Swal.showLoading();

    this.inspectionService.getReportVersions(this.inspId)
      .pipe(
        takeUntil(this.destroy$),
        catchError(e => {
          this.alertService.errorToast(MESSAGES.ERRORS.FailedToLoadInspectionReportVersion);
          Swal.close();
          return of([]);
        })
      )
      .subscribe(res => {
        this.reportVersions = res
            .sort((a, b) => new Date(a.updatedOn).getTime() - new Date(b.updatedOn).getTime())
            .map((item, index) => ({
            ...item,
            version: index + 1
          }));

        this.isLoading = false;
        Swal.close();
      });
  }

  close() {
    this.downloadLinks.forEach(l => l.remove());
    this.activeModal.close();
  }

  downloadReports(e: MouseEvent) {
    e.preventDefault();

    if (this.selectedVersions.size > 0) {
      const urls = this.reportVersions.filter(
        r => this.selectedVersions.has(r.id))
        .map(r => r.inspectionReportUrl);
      urls.forEach(url => {
        const iframe = document.createElement('iframe');
        iframe.setAttribute('sandbox', 'allow-downloads allow-scripts');
        iframe.src = url;
        iframe.setAttribute('style', 'display: none');
        this.downloadLinks.push(iframe);
        document.body.appendChild(iframe);

      });
    }
  }

  isSelected(id: number) {
    return this.selectedVersions.has(id);
  }

  onCheckboxChange(id: number, isChecked: boolean) {
    if (isChecked) {
      this.selectedVersions.add(id);
    } else {
      this.selectedVersions.delete(id);
    }
    this.selectAll = this.reportVersions.length === this.selectedVersions.size;
  }

  selectAllVersions(allSelected: boolean) {
    if (allSelected) {
      this.selectedVersions = new Set(this.reportVersions.map(r => r.id));
    } else {
      this.selectedVersions = new Set();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
